import './style.scss';
/*----------------
	JS Work only front side
 ---------------*/